// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router",}[chunkId] || chunkId) + "." + {"144": "4c708189","264": "51303413","282": "cfa0262d","284": "e1b469bc","31": "600d0a29","354": "947f30a9","466": "4b3f689d","535": "012453ef","625": "1e94ae28","640": "dc859832","689": "ac2bf8eb","760": "ba2db6c1","787": "d3c925a7","878": "b774d1d2",}[chunkId] + ".js"
}